/*  ==========================================================================
    SLIDE BOX

    INFO:
    - needs "masonry-layout" for tile output if slide box has only images and
      no text
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'lodash/lodash.js';
import Masonry from 'masonry-layout';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initSlideBox($element) {

    // magnific popup
    utils.mfp.initGallery($element);

    // accordion function
    utils.accordions.initSimpleAccordion($element);

    // masonry (if slide box has only images and no text)
    if ($element.hasClass('bn-slide-box--no-text')) {
        let masonry,
            masonryGrid = $element.find('.bn-slide-box__images')[0],
            masonryOptions = {
                columnWidth: '.bn-slide-box__image',
                itemSelector: '.bn-slide-box__image',
                percentPosition: true
            };

        // initialize
        if ($element.hasClass('bn-accordion--opened')) {

            // on load if accordion is opened
            if (!$element.hasClass('masonry-act')) {
                masonry = new Masonry(masonryGrid, {masonryOptions});
                $element.addClass('masonry-act');
            }

        } else {

            // on click if accordion is closed
            $element.on('click', '.bn-accordion__trigger', function () {
                if (!$element.hasClass('masonry-act')) {
                    setTimeout(function () {
                        masonry = new Masonry(masonryGrid, {masonryOptions});
                        $element.addClass('masonry-act');
                    }, 500);
                }
            });

        }

        // reinitialize on resize
        if ($element.hasClass('masonry-act')) {
            vars.$page.on('mresize', _.debounce(function () {
                masonry.layout();
            }, 500));
        }

    }

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/slide-box.js